import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import ModalBase from '../..';
import { useEntityContext } from '../../../../../pages/financials/EntityContext/hooks';
import Button from '../../../../atoms/Button';
import { ButtonKind } from '../../../../atoms/Button/enums';
import Loader from '../../../../atoms/Loader';
import { LoaderMode } from '../../../../atoms/Loader/enums';
import Table from '../../../../molecules/Table';
import ScCard from '../../../../atoms/ScCard';
import { useSettlementDetails, useTableColumns } from './hooks';
import { FinancialsEntitySelectModalProps } from './types';

const FinancialsEntitySelectModal: React.FC<FinancialsEntitySelectModalProps> =
  ({ onCashOut, onClose, ...props }) => {
    const intl = useIntl();
    const { data, isLoading } = useSettlementDetails();
    const { hasSelectedEntities, tableColumns } = useTableColumns();
    const { clearSelection } = useEntityContext();

    const onModalClose = useCallback(
      (event?: React.MouseEvent<HTMLButtonElement>) => {
        if (onClose) {
          clearSelection();
          onClose(event);
        }
      },
      [clearSelection, onClose]
    );

    return (
      <ModalBase {...props} onClose={onModalClose}>
        <div style={{ maxWidth: '56rem', margin: '0 auto', padding: '0 var(--s-5)' }}>
          {/* Header */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 'var(--s-5)',
          }}>
            <div>
              <div style={{ fontSize: 'var(--t-xl)', fontWeight: 700, color: 'var(--ink)', letterSpacing: '-0.015em' }}>
                {intl.formatMessage({ id: 'financials.cashOutTitle', defaultMessage: 'Cash out' })}
              </div>
              <div style={{ fontSize: 'var(--t-sm)', color: 'var(--muted)', marginTop: 4 }}>
                {intl.formatMessage({ id: 'financials.cashOutSub', defaultMessage: 'Select the entities you want to settle' })}
              </div>
            </div>
            <Button
              kind={ButtonKind.Primary}
              type='button'
              onClick={onCashOut}
              disabled={!hasSelectedEntities}
            >
              {intl.formatMessage({ id: 'financials.cashOut', defaultMessage: 'Cash Out' })}
            </Button>
          </div>

          {/* Table card */}
          <ScCard pad={false}>
            {isLoading ? (
              <div style={{ padding: 'var(--s-6)' }}>
                <Loader mode={LoaderMode.Table} />
              </div>
            ) : (
              <Table data={data} columns={tableColumns} disabledPagination />
            )}
          </ScCard>
        </div>
      </ModalBase>
    );
  };

export default FinancialsEntitySelectModal;
